import React, { useEffect, useState, useCallback } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { isMobileOnly } from 'react-device-detect';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import { setCurrencyFormat } from '../../../../utils/helpers';
import { tablePageTrafficWithConversionHeader } from '../../helper';
import { getPageTrafficWithConversionData, handleLoader, getPageTrafficWithConversionDataForGraph, handleGraphLoader }
    from '../../../../redux/actions/PageTrafficWithConversionAction';
import ViewsVsSalesTable from './ViewsVsSalesTable';
import ViewsVsSalesShow from './ViewsVsSalesShow';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';

const PageTrafficWithConversion = ({ dispatch, rtl }) => {
    const { t } = useTranslation('common');
    const location = useLocation();

    const { pageTrafficWithConversionData, salesChannelFilterData, isLoading, 
            pageTrafficWithConversionForGraphData, isGraphLoading } = useSelector(
        ({ pageTrafficWithConversionReducer, marketPlaceReducer }) =>
        ({
            pageTrafficWithConversionData: pageTrafficWithConversionReducer.pageTrafficWithConversionData,
            isLoading: pageTrafficWithConversionReducer.isLoading,
            pageTrafficWithConversionForGraphData: pageTrafficWithConversionReducer.
                                                    pageTrafficWithConversionForGraphData,
            isGraphLoading: pageTrafficWithConversionReducer.isGraphLoading,
            salesChannelFilterData: marketPlaceReducer.salesChannel,

        })
    );

    const previousMonthDate = new Date();
    previousMonthDate.setMonth(previousMonthDate.getMonth() - 1)

    const [pageTrafficWithConversionDataToShow, setDataToShow] = useState([])
    const [pageTrafficWithConversionDataForGraphToShow, setDataForGraphToShow] = useState([])
    const [isOpen, setIsOpen] = useState(false);
    const [filterData, setFilterData] = useState({});
    const [fromDate, setFromDate] = useState(previousMonthDate);
    const [toDate, setToDate] = useState(new Date());
    const [skus, setSkus] = useState()
    const [sku, setSku] = useState(null)

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };

    const skuOptions = () => {
        const options = [];
        skus?.filterData?.forEach((skuItem) => {
            if (skuItem.longValue) {
                options.push({ value: skuItem.longValue, label: skuItem.key })
            }
        })

        return options
    }

    const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    dvTb.style.display = "none";  
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Page Traffic ( views vs sales ) with conversion Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
  }

    const filterBasedOnFilter = (item) => {
        const filters = Object.keys(filterData);
        let flag = true
        // eslint-disable-next-line no-restricted-syntax
        for (const i of filters) {
            const filter = filterData[i];
            const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value?.toLowerCase()], []) ?? [];
            if (filtersArray?.length && !filtersArray.includes(item?.[i]?.toLowerCase())) {
                flag = false
            }
        }
        return flag
    }

    const callApi = () => {
        dispatch(handleLoader(true));
        dispatch(getPageTrafficWithConversionData(
            {
                fromdate: moment(fromDate).format('YYYY-MM-DD'),
                todate: moment(toDate).format('YYYY-MM-DD'),
                sku: sku === null ? '' : sku.value
            }
        ));
        dispatch(handleGraphLoader(true));
        dispatch(getPageTrafficWithConversionDataForGraph(
            {
                fromdate: moment(fromDate).format('YYYY-MM-DD'),
                todate: moment(toDate).format('YYYY-MM-DD'),
                sku: sku === null ? '' : sku.value
            }
        ));
    }

    const handleApplyDate = () => {
        callApi()
    }

    useEffect(() => {
        dispatch(handleLoader(true));
        dispatch(handleGraphLoader(true));
        callApi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        setDataToShow(pageTrafficWithConversionData?.modal?.data || []);
        setDataForGraphToShow(pageTrafficWithConversionForGraphData?.modal?.data || []);
        setSkus(pageTrafficWithConversionData?.modal?.filters?.[0] || []);
    }, [pageTrafficWithConversionData, pageTrafficWithConversionForGraphData]);

    useEffect(() => {
        const OptChennel = 'salesChannel';
        setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [salesChannelFilterData])

    let dataToShowForDatesSelected = pageTrafficWithConversionDataToShow?.filter(item => filterBasedOnFilter(item))
    let dataForGraphToShowForDatesSelected = pageTrafficWithConversionDataForGraphToShow?.
                                                filter(item => filterBasedOnFilter(item))

    if (sku != null) {        
        dataToShowForDatesSelected = dataToShowForDatesSelected?.filter(item => item.sku === sku.value)
        dataForGraphToShowForDatesSelected = dataForGraphToShowForDatesSelected?.filter(item => item.sku === sku.value)
    }
    

    const viewReportButton = () => (
        <div className="view-report">
            <button
                type="button"
                className="view-report btn btn-primary btn-sm"
                onClick={() => setIsOpen(true)}
                disabled={!dataToShowForDatesSelected.length && !dataForGraphToShowForDatesSelected.length}
            >
                View Report
            </button>
        </div>
    )

    return (
        <Container className="dashboard">
            <Row className="category-sales">
                <Col sm="12">
                    <Card className="pb-3">
                        <CardBody className="min-w-50 p-3">
                            <div className="card__title mb-2">
                                <h5 className="bold-text card__title-center">
                                    Page Traffic ( views vs sales ) with conversion</h5>
                            </div>                            
                            <Row className="align-items-center">
                                <Col sm="3">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">SKU</span>
                                        <div className="form__form-group-field">
                                            <Select
                                                value={sku}
                                                options={skuOptions()}
                                                clearable={false}
                                                placeholder="Select "
                                                className="select_filter-200"
                                                onChange={value => setSku(value)}
                                                classNamePrefix="react-select"
                                            // isMulti
                                            />
                                        </div>

                                    </div>
                                </Col>
                                <Col sm="3">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">From Date</span>
                                        <div className="form__form-group-field">
                                            <div className="date-picker">
                                                <DatePicker
                                                    className="form__form-group-datepicker"
                                                    selected={moment(fromDate).toDate()}
                                                    showPreviousMonths
                                                    onChange={handleFromDateChange}
                                                    dateFormat="MM/dd/yyyy"
                                                    dropDownMode="select"
                                                    popperPlacement="center"
                                                    withPortal={isMobileOnly}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm="3">
                                    <div className="form__form-group mb-0">
                                        <span className="form__form-group-label">To Date</span>
                                        <div className="form__form-group-field">
                                            <div className="date-picker">
                                                <DatePicker
                                                    className="form__form-group-datepicker"
                                                    selected={moment(toDate).toDate()}
                                                    onChange={handleToDateChange}
                                                    dateFormat="MM/dd/yyyy"
                                                    dropDownMode="select"
                                                    popperPlacement="center"
                                                    withPortal={isMobileOnly}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col sm="3" style={{ top: '10px' }}>
                                    <button className="btn btn-sm btn-primary apply-date-button"
                                        type="button" onClick={handleApplyDate}>
                                        Apply</button>
                                        <button 
                                            className="btn btn-sm btn-primary apply-date-button"   
                                            type="button"
                                            title='Export to pdf' 
                                            disabled={isLoading}
                                            onClick={exportToPDF}
                                        >
                                            Export PDF
                                        </button>
                                </Col>
                            </Row>                              
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <div id="divToPrint" ref={container}>
            <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                    >
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <ViewsVsSalesShow
                                    title="Page Traffic With Conversion"
                                    viewReportButton={viewReportButton}
                                    data={dataForGraphToShowForDatesSelected}
                                    dir={rtl.direction}
                                />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                        style={{ minHeight: '400' }}>
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <ViewsVsSalesTable
                                    data={dataToShowForDatesSelected}
                                    tableHeaderData={tablePageTrafficWithConversionHeader}
                                />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            </div>
            {/* <ViewSalesReportModal
        modalData={dataToShowForDatesSelected}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tablePageTrafficWithConversionHeader}
      />   */}
        </Container>
    );
};

PageTrafficWithConversion.propTypes = {
    dispatch: PropTypes.func.isRequired,
    rtl: RTLProps.isRequired,
}

export default connect(state => ({
    rtl: state.rtl,
}))(PageTrafficWithConversion)